<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <path d="M2.25 18.003H21.75" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.25 12.003H21.75" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.25 6.003H21.75" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
